import { Capacitor } from '@capacitor/core';
import { CapacitorPushService } from './capacitor-push-service';
import { FirebasePushService } from './firebase-push-service';
import type { PushNotificationService } from '../types/push-notification-service.interface';
import type { NotificationPayload } from '../types/notification-types';

/**
 * Coordinates push notifications across platforms
 * Automatically selects the appropriate service based on platform
 */
export class PushNotificationCoordinator implements PushNotificationService {
  private service: PushNotificationService;

  constructor() {
    // Choose service based on platform
    if (Capacitor.isNativePlatform()) {
      this.service = new CapacitorPushService();
    } else {
      this.service = new FirebasePushService();
    }
  }

  async initialize(): Promise<void> {
    return this.service.initialize();
  }

  async requestPermission(): Promise<boolean> {
    return this.service.requestPermission();
  }

  async getToken(): Promise<string | null> {
    return this.service.getToken();
  }

  onTokenRefresh(callback: (token: string) => void): void {
    this.service.onTokenRefresh(callback);
  }

  onMessage(callback: (message: any) => void): void {
    this.service.onMessage(callback);
  }

  onAction(callback: (payload: NotificationPayload) => void): void {
    this.service.onAction(callback);
  }

  cleanup(): void {
    this.service.cleanup();
  }
}
